import { configureStore } from '@reduxjs/toolkit';
import ridesReducer from './Slices/ridesSlice';
import tokenReducer from "./Slices/tokenSlice";
import snackbarReducer from "./Slices/snackbarSlice";
import toastReducer from "./Slices/toastSlice";


export const store = configureStore({
    reducer: {
        rides: ridesReducer,
        token: tokenReducer,
        snackbar: snackbarReducer,
        toast: toastReducer,
    },
});